import type {
    IInvitationResponse,
    ICreateInvitation,
    IPublicInvitationResponse,
    IAcceptInvitation,
    IAcceptInvitationResponse,
} from '@escloud/types';

import type { ApiClient } from './api-client';

export class InvitationsService {
    constructor(private api: ApiClient) {}

    getTenantInvitations(tenantId: string): Promise<{ items: IInvitationResponse[] }> {
        return this.api.get<{ items: IInvitationResponse[] }>(`/tenants/${tenantId}/invitations`);
    }

    createInvitation(
        tenantId: string,
        data: ICreateInvitation
    ): Promise<{ invitation: IInvitationResponse }> {
        return this.api.post<{ invitation: IInvitationResponse }>(`/tenants/${tenantId}/members`, data);
    }

    revokeInvitation(tenantId: string, invitationId: string): Promise<void> {
        return this.api.delete<void>(`/tenants/${tenantId}/invitations/${invitationId}`);
    }

    getPublicInvitation(token: string, baseUrl?: string): Promise<IPublicInvitationResponse> {
        return this.api.get<IPublicInvitationResponse>(`/invitations/${token}`, { skipAuth: true, baseUrl });
    }

    acceptInvitation(data: IAcceptInvitation, baseUrl?: string): Promise<IAcceptInvitationResponse> {
        return this.api.post<IAcceptInvitationResponse>('/invitations/accept', data, { baseUrl });
    }
}
